/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Create prebooking
 * @export
 * @interface PreBookingRequest
 */
export interface PreBookingRequest {
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    email?: string;
    /**
     *
     * @type {number}
     * @memberof PreBookingRequest
     */
    customerId?: number;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    jwtToken?: string;
    /**
     *
     * @type {number}
     * @memberof PreBookingRequest
     */
    latitude: number;
    /**
     *
     * @type {number}
     * @memberof PreBookingRequest
     */
    longitude: number;
    /**
     *
     * @type {number}
     * @memberof PreBookingRequest
     */
    locationId: number;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    vehicleCategory: PreBookingRequestVehicleCategoryEnum;
    /**
     *
     * @type {number}
     * @memberof PreBookingRequest
     */
    rentalStartsAtMillis: number;
    /**
     *
     * @type {number}
     * @memberof PreBookingRequest
     */
    rentalEndsAtMillis: number;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    countryOfResidence?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    phoneNumber?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    language: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    address: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    selectedOfferToken?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    decodedOfferToken?: string;
    /**
     *
     * @type {Array<number>}
     * @memberof PreBookingRequest
     */
    selectedExtraIds?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    leadGenerator?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    leadPlatform?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    partnerBookingId?: string;
    /**
     *
     * @type {string}
     * @memberof PreBookingRequest
     */
    uuid?: string;
    /**
     *
     * @type {number}
     * @memberOf PreBookingRequest
     */
    paymentProfileId?: number;

    /**
     *
     * @type {string}
     * @memberOf PreBookingRequest
     */
    webviewVersion: string;

    /**
     *
     * @type {string}
     * @memberOf PreBookingRequest
     */
    appVersion: string;

    /**
     *
     * @type {string}
     * @memberOf PreBookingRequest
     */
    platform: string;

    /**
     * @type {string}
     * @memberOf PreBookingRequest
     */
    paymentAuthorizationId?: string
    /**
     *
     * @type {boolean}
     * @memberOf PreBookingRequest
     */
    creditBackApplied?: boolean;
}


/**
 * @export
 */
export const PreBookingRequestVehicleCategoryEnum = {
    XS: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    XSC: 'XSC',
    SC: 'SC',
    MC: 'MC',
    LC: 'LC',
    XSE: 'XSE',
    SE: 'SE',
    ME: 'ME',
    LE: 'LE',
    XL: 'XL'
} as const;
export type PreBookingRequestVehicleCategoryEnum = typeof PreBookingRequestVehicleCategoryEnum[keyof typeof PreBookingRequestVehicleCategoryEnum];


/**
 * Check if a given object implements the PreBookingRequest interface.
 */
export function instanceOfPreBookingRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "latitude" in value;
    isInstance = isInstance && "longitude" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "vehicleCategory" in value;
    isInstance = isInstance && "rentalStartsAtMillis" in value;
    isInstance = isInstance && "rentalEndsAtMillis" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "address" in value;

    return isInstance;
}

export function PreBookingRequestFromJSON(json: any): PreBookingRequest {
    return PreBookingRequestFromJSONTyped(json, false);
}

export function PreBookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'email': !exists(json, 'email') ? undefined : json['email'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'jwtToken': !exists(json, 'jwtToken') ? undefined : json['jwtToken'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'locationId': json['locationId'],
        'vehicleCategory': json['vehicleCategory'],
        'rentalStartsAtMillis': json['rentalStartsAtMillis'],
        'rentalEndsAtMillis': json['rentalEndsAtMillis'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'countryOfResidence': !exists(json, 'countryOfResidence') ? undefined : json['countryOfResidence'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'language': json['language'],
        'address': json['address'],
        'selectedOfferToken': !exists(json, 'selectedOfferToken') ? undefined : json['selectedOfferToken'],
        'decodedOfferToken': !exists(json, 'decodedOfferToken') ? undefined : json['decodedOfferToken'],
        'selectedExtraIds': !exists(json, 'selectedExtraIds') ? undefined : json['selectedExtraIds'],
        'leadGenerator': !exists(json, 'leadGenerator') ? undefined : json['leadGenerator'],
        'leadPlatform': !exists(json, 'leadPlatform') ? undefined : json['leadPlatform'],
        'partnerBookingId': !exists(json, 'partnerBookingId') ? undefined : json['partnerBookingId'],
        'webviewVersion': !exists(json, 'webviewVersion') ? undefined : json['webviewVersion'],
        'appVersion': !exists(json, 'appVersion') ? undefined : json['appVersion'],
        'platform': !exists(json, 'platform') ? undefined : json['platform'],
        'paymentAuthorizationId': !exists(json, 'paymentAuthorizationId') ? undefined : json['paymentAuthorizationId'],
        'creditBackApplied': !exists(json, 'creditBackApplied') ? undefined : json['creditBackApplied'],
    };
}

export function PreBookingRequestToJSON(value?: PreBookingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'customerId': value.customerId,
        'jwtToken': value.jwtToken,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'locationId': value.locationId,
        'vehicleCategory': value.vehicleCategory,
        'rentalStartsAtMillis': value.rentalStartsAtMillis,
        'rentalEndsAtMillis': value.rentalEndsAtMillis,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'countryOfResidence': value.countryOfResidence,
        'phoneNumber': value.phoneNumber,
        'language': value.language,
        'address': value.address,
        'selectedOfferToken': value.selectedOfferToken,
        'decodedOfferToken': value.decodedOfferToken,
        'selectedExtraIds': value.selectedExtraIds,
        'leadGenerator': value.leadGenerator,
        'leadPlatform': value.leadPlatform,
        'partnerBookingId': value.partnerBookingId,
        'paymentProfileId': value.paymentProfileId,
        'uuid': value.uuid,
        'webviewVersion': value.webviewVersion,
        'platform': value.platform,
        'appVersion': value.appVersion,
        'paymentAuthorizationId': value.paymentAuthorizationId,
        'creditBackApplied': value.creditBackApplied,
    };
}

